import _ from 'lodash';
import { weightToLength, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { FTProcess } from '@/models/FTProcess';
import { ConversionDetails } from '@/models/ConversionDetails';
import { convertStep } from './CConvertStep';
import { compareStringIgnoreCase } from '@/utils';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            form: ['roll']
          },
          multiple: false,
          params: [
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              enableConvertFnIf: compareStringIgnoreCase(_.get(processRow, 'goodsObject.rawMaterialUnit', ''),'SQM'),
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'multiple',
      arguments: [
        {
          name: 'Width',
          type: 'dimension',
          value: 'width',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Output Quantity',
          type: 'quantity',
          value: 'quantity',
          enableConvertFnIf: compareStringIgnoreCase(_.get(processRow, 'goodsObject.rawMaterialUnit', ''),'SQM'),
          disabled: false
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'Linear Length',
        value: 'linearMeters'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  let totalInputQuantity = 0;
  let linearLength = 0;
  let netWeight = 0;
  conversionResult.details.totalQuantity = 0;
  conversionResult.outputs = convertStep.slitting(process.inputs[0])
  _.each(process.inputs, (processInputRow) => {
    linearLength += weightToLength(processInputRow.quantity, processInputRow.goodsObject.density, processInputRow.goodsObject.dimensions ? processInputRow.goodsObject.dimensions.width : 0);
    totalInputQuantity += processInputRow.quantity;
  })
  _.each(conversionResult.outputs, (outputFTProcessRow) => {
    netWeight += outputFTProcessRow.quantity;
    conversionResult.details.totalQuantity += outputFTProcessRow.quantity;
  })
  conversionResult.details.linearMeters = linearLength;
  conversionResult.details.wastePercentage = totalInputQuantity ? ((totalInputQuantity - netWeight) / totalInputQuantity) * 100 : 0;
  conversionResult.details.waste = (conversionResult.details.wastePercentage * totalInputQuantity) / 100;
  conversionResult.details.netWeight = netWeight;
  conversionResult.details.kgPerHour = 60 * process.machineDetail.mechanicalSpeed * (conversionResult.outputs[0].dimensions.width / 1000) * conversionResult.outputs[0].goodsObject.density;
  conversionResult.details.plannedHours = (conversionResult.details.totalQuantity + conversionResult.details.waste) / conversionResult.details.kgPerHour;

  return conversionResult;
}